"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.removeRelatedItem = removeRelatedItem;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _lodash = _interopRequireDefault(require("lodash"));

var _invariant = _interopRequireDefault(require("invariant"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context7; _forEachInstanceProperty(_context7 = ownKeys(Object(source))).call(_context7, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Remove related item from state
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */
function removeRelatedItem(state, action) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      type = _action$payload.type;
  (0, _invariant.default)(id, 'You need to define the ID of the item you want to remove!');
  (0, _invariant.default)(type, 'You need to define the type of the item you want to remove!');
  var newState = null;

  var _loop = function _loop(_id) {
    var item = state[_entityNormalizer.ITEMS][_id];

    for (var name in item.related) {
      var related = item[_entityNormalizer.RELATED][name];

      if (related) {
        var relatedType = _lodash.default.isArray(related.type) ? related.type[0] : related.type;

        if (relatedType === type) {
          var _context, _context2, _context3, _context4, _context5;

          if (!newState) {
            // Just spreading once to ensure state immutablity without creating
            // memory leaks / overheads
            newState = _objectSpread({}, state);
          }

          var dataKey = (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = "".concat(_entityNormalizer.ITEMS, ".")).call(_context4, _id, ".")).call(_context3, _entityNormalizer.RELATED, ".")).call(_context2, name, ".")).call(_context, _entityNormalizer.ITEMS);
          var data = (0, _filter.default)(_context5 = _lodash.default.get(related, _entityNormalizer.ITEMS, [])).call(_context5, function (itemId) {
            return itemId !== _id;
          });
          newState = _lodash.default.set(newState, dataKey, data);
        }
      }
    }
  };

  for (var _id in state[_entityNormalizer.ITEMS]) {
    _loop(_id);
  } // Only return new state if anything changed, otherwise return the
  // old state instance


  if (newState) {
    return newState;
  }

  return state;
}